import useSettingsStore from '@store/settingsStore'
import { cn } from 'utils/classnames'

const VaultSectionHeading = ({ heading }: { heading: string }) => {
  const isPro = useSettingsStore((state) => state.isPro())

  const sectionHeight = isPro ? 'h-[24px]' : 'h-[26px] lg:h-[32px]'
  const paddingX = isPro ? 'px-4' : 'px-4 lg:px-6'
  const headingFont = isPro ? 'text-sm' : 'text-sm lg:text-lg'

  return (
    <div
      className={cn(
        'relative flex items-center border-y border-th-input-border bg-th-bkg-3',
        sectionHeight,
        paddingX,
      )}
    >
      <div
        className={cn('font-semibold leading-none text-th-fgd-1', headingFont)}
      >
        {heading}
      </div>
    </div>
  )
}

export default VaultSectionHeading
